import {REQUEST_ERROR, REQUEST_START, REQUEST_SUCCESS} from '../../../middlewares/api/actions';
import {combineReducers} from 'redux';
import {
  IMPORT_ATTRIBUTE_CATEGORISED_CUBES_READ,
  IMPORT_ATTRIBUTE_CHANGE,
  IMPORT_ATTRIBUTE_CUBE_READ,
  IMPORT_ATTRIBUTE_CUBE_SET,
  IMPORT_ATTRIBUTE_CUBE_TREE_HIDE,
  IMPORT_ATTRIBUTE_CUBE_TREE_SHOW,
  IMPORT_ATTRIBUTE_CUBE_UNSET,
  IMPORT_ATTRIBUTE_FILE_UPLOAD,
  IMPORT_ATTRIBUTE_IGNORE_CONCURRENT_UPLOAD_CONFIRM_HIDE,
  IMPORT_ATTRIBUTE_SUBMIT
} from './actions';
import attributeFileFormRowListReducer from './row-list/reducer';
import {getCubesTree} from "../../../utils/treeBuilders";
import {
  DEFAULT_CATEGORY_SCHEME_SELECTOR_CREATE_SUBMIT,
  DEFAULT_CATEGORY_SCHEME_SELECTOR_SELECT_SUBMIT
} from "../../../middlewares/default-category-scheme-selector/actions";
import _ from "lodash";

const attributeFileReducer = combineReducers({
  components: combineReducers({
    rowList: attributeFileFormRowListReducer
  }),
  shared: (
    state = {
      separator: ";",
      delimiter: null,
      csvServerPath: null,
      tid: null
    },
    action
  ) => {
    switch (action.type) {
      case IMPORT_ATTRIBUTE_CUBE_UNSET:
        return {
          ...state,
          separator: ";",
          delimiter: null,
          csvServerPath: null,
          tid: null
        };
      case IMPORT_ATTRIBUTE_CHANGE:
        const {
          separator,
          delimiter,
          file,
          tid,
        } = _.mapValues(action.fields, field => field.value);
        return {
          ...state,
          tid: tid !== undefined ? tid : state.tid,
          csvServerPath: (
            (separator !== undefined && separator !== state.separator) ||
            (delimiter !== undefined && delimiter !== state.delimiter)
          )
            ? null
            : (file === null ? null : state.csvServerPath),
          separator: file === null ? ";" : (separator !== undefined ? separator : state.separator),
          delimiter: file === null ? null : (delimiter !== undefined ? delimiter : state.delimiter)
        };
      case REQUEST_START:
        switch (action.label) {
          case IMPORT_ATTRIBUTE_FILE_UPLOAD:
            return {
              ...state,
              csvServerPath: null
            };
          default:
            return state;
        }
      case REQUEST_SUCCESS:
        switch (action.label) {
          case IMPORT_ATTRIBUTE_FILE_UPLOAD:
            return {
              ...state,
              csvServerPath: action.response
            };
          case IMPORT_ATTRIBUTE_SUBMIT:
            return {
              ...state,
              separator: ";",
              delimiter: null,
              csvServerPath: null,
              tid: null
            }
          default:
            return state;
        }
      default:
        return state;
    }
  },
  local: (
    state = {
      file: null,
      cubeId: null,
      cube: null,
      categorisedCubes: null,
      isCubeTreeVisible: false,
      checkFiltAttributes: false,
      refreshProdDf: false,
      isIgnoreConcurrentUploadConfirmVisible: false
    },
    action
  ) => {
    switch (action.type) {
      case IMPORT_ATTRIBUTE_CUBE_TREE_SHOW:
        return {
          ...state,
          isCubeTreeVisible: true,
        };
      case IMPORT_ATTRIBUTE_CUBE_TREE_HIDE:
        return {
          ...state,
          isCubeTreeVisible: false,
          categorisedCubes: null,
        };
      case IMPORT_ATTRIBUTE_CUBE_SET:
        return {
          ...state,
          cubeId: action.cubeId,
          isCubeTreeVisible: false,
          categorisedCubes: null,
        };
      case IMPORT_ATTRIBUTE_CUBE_UNSET:
        return {
          ...state,
          cubeId: null,
          cube: null,
          file: null,
          refreshProdDf: false,
          checkFiltAttributes: false
        };
      case IMPORT_ATTRIBUTE_CHANGE:
        const {
          file,
          refreshProdDf,
          checkFiltAttributes
        } = _.mapValues(action.fields, field => field.value);
        return {
          ...state,
          file: file !== undefined ? file : state.file,
          refreshProdDf: refreshProdDf !== undefined ? refreshProdDf : state.refreshProdDf,
          checkFiltAttributes: checkFiltAttributes !== undefined ? checkFiltAttributes : state.checkFiltAttributes
        };
      case IMPORT_ATTRIBUTE_IGNORE_CONCURRENT_UPLOAD_CONFIRM_HIDE:
        return {
          ...state,
          isIgnoreConcurrentUploadConfirmVisible: false
        };
      case REQUEST_START: {
        switch (action.label) {
          case IMPORT_ATTRIBUTE_CATEGORISED_CUBES_READ:
            return {
              ...state,
              categorisedCubes: null
            };
          default:
            return state;
        }
      }
      case REQUEST_SUCCESS: {
        switch (action.label) {
          case IMPORT_ATTRIBUTE_CATEGORISED_CUBES_READ:
            return {
              ...state,
              categorisedCubes: getCubesTree(action.response[0], action.response[1])
            };
          case DEFAULT_CATEGORY_SCHEME_SELECTOR_SELECT_SUBMIT:
          case DEFAULT_CATEGORY_SCHEME_SELECTOR_CREATE_SUBMIT:
            return {
              ...state,
              categorisedCubes: null
            };
          case IMPORT_ATTRIBUTE_CUBE_READ:
            return {
              ...state,
              cube: action.response
            };
          case IMPORT_ATTRIBUTE_SUBMIT:
            return {
              ...state,
              file: null,
              cubeId: null,
              cube: null,
              categorisedCubes: null,
              isCubeTreeVisible: false,
              checkFiltAttributes: false,
              refreshProdDf: false,
              isIgnoreConcurrentUploadConfirmVisible: false
            }
          default:
            return state;
        }
      }
      case REQUEST_ERROR: {
        switch (action.label) {
          case IMPORT_ATTRIBUTE_CATEGORISED_CUBES_READ:
            return {
              ...state,
              isCubeTreeVisible: false,
              categorisedCubes: []
            };
          case IMPORT_ATTRIBUTE_SUBMIT:
            if (action.error && action.error.errorCode === "LOADING_CONCURRENT_UPLOAD_SAME_CUBE") {
              return {
                ...state,
                isIgnoreConcurrentUploadConfirmVisible: true
              }
            } else {
              return state;
            }
          default:
            return state;
        }
      }
      default:
        return state;
    }
  }
});

export default attributeFileReducer;



// WEBPACK FOOTER //
// ./src/scenes/data-manager/attribute-file/reducer.js